/** Browser localStorage key for full consent record. */
export const CONSENT_STORAGE_KEY = "autoplus_cookie_consent";

/** First-party cookie mirrored for server awareness (never in URL). */
export const CONSENT_COOKIE_NAME = "app_cookie_consent";

export const CONSENT_VERSION = 1;

/** One year · consent preference lifetime. */
export const CONSENT_MAX_AGE_SEC = 365 * 24 * 60 * 60;

export type ConsentChoice = "all" | "essential";

export interface CookieConsentRecord {
  v: number;
  essential: true;
  functional: boolean;
  analytics: boolean;
  ts: number;
}

export function choiceToRecord(choice: ConsentChoice): CookieConsentRecord {
  const allowOptional = choice === "all";
  return {
    v: CONSENT_VERSION,
    essential: true,
    functional: allowOptional,
    analytics: allowOptional,
    ts: Date.now(),
  };
}

export function encodeConsentCookie(choice: ConsentChoice): string {
  return `v${CONSENT_VERSION}:${choice === "all" ? "all" : "essential"}`;
}

export function parseConsentCookie(value: string | null | undefined): ConsentChoice | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (trimmed === `v${CONSENT_VERSION}:all`) return "all";
  if (trimmed === `v${CONSENT_VERSION}:essential`) return "essential";
  return null;
}

export function isConsentRecordCurrent(
  record: CookieConsentRecord | null | undefined,
): record is CookieConsentRecord {
  return Boolean(record && record.v === CONSENT_VERSION && record.essential === true);
}
